package com.eladfinish.bible.contest.screens.search.history

import com.eladfinish.bible.contest.constants.Constants
import com.russhwolf.settings.Settings

/**
 * Decides when to tell the user, once, that searches are being saved to the history.
 *
 * The hint is held back until the search ends, because while a search runs its progress dialog
 * covers the snackbar. It is marked as shown the moment it is handed over for display, and also
 * when the user opens the history on their own -- there is nothing left to point out then.
 */
class SearchHistoryHint(
    private val settings: Settings,
) {

    private var isPending = false

    private val wasShown: Boolean
        get() = settings.getBoolean(Constants.PREF_SEARCH_HISTORY_HINT_SHOWN, defaultValue = false)

    /** Call with whether the click actually started a search, i.e. whether it was recorded. */
    fun onSearchClicked(startsSearch: Boolean) {
        if (startsSearch && !wasShown) {
            isPending = true
        }
    }

    /** True exactly once: the caller must show the hint when it gets true. */
    fun shouldShowWhenSearchEnds(): Boolean {
        if (!isPending || wasShown) return false

        markShown()
        return true
    }

    fun onHistoryOpened() {
        markShown()
    }

    private fun markShown() {
        isPending = false
        settings.putBoolean(Constants.PREF_SEARCH_HISTORY_HINT_SHOWN, true)
    }
}
